// The Halloween ghost's sound (home hero, [data-boo]).
//
// Tap the ghost: a five-second swell of wind (assets/audio/boo-wind.mp3,
// from Pixabay's free library) and a little jump. Nothing plays on its
// own, and the file only downloads on the first tap.

const VOLUME = 0.6;

export default function boo() {
    document.querySelectorAll("[data-boo]").forEach((btn) => {
        let audio;

        btn.addEventListener("click", () => {
            if (btn.dataset.booSrc) {
                audio = audio || new Audio(btn.dataset.booSrc);
                audio.volume = VOLUME;
                audio.currentTime = 0;
                audio.play().catch(() => { /* blocked or failed: the ghost still jumps */ });
            }
            btn.classList.remove("is-booing");
            void btn.offsetWidth;
            btn.classList.add("is-booing");
        });

        btn.addEventListener("animationend", (e) => {
            if (e.animationName === "gg-boo-jump") btn.classList.remove("is-booing");
        });
    });
}
